import React from 'react';
import useDispatch from '@/util/hook/useDispatch';
import useSelector from '@/util/hook/useSelector';
import { careOrderBabyFormUpdatePartTimeTimeSlotList, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import View from './View';
import { POPUP_TYPE } from '../../config/popup';
const getIsChoiceChipSelected = ({ optionExpectedStartTime, timeSlotList, }) => {
    const isSelected = timeSlotList.some((timeSlot) => timeSlot.expectedStartTime === optionExpectedStartTime);
    return isSelected;
};
const handleChoiceChipClick = ({ dispatch, optionExpectedStartTime, }) => dispatch(careOrderBabyFormUpdatePartTimeTimeSlotList({
    expectedStartTime: optionExpectedStartTime,
}));
export default function Controller({ popupType, setPopupType, partTimeTimeSlotOptionList, }) {
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const timeSlotList = careOrderBabyForm.timeSlotList;
    const didCompleteRequiredFormFields = timeSlotList.length > 0;
    const dispatch = useDispatch();
    return (<View 
    // data
    popupType={popupType} partTimeTimeSlotOptionList={partTimeTimeSlotOptionList} isForwardButtonAvailable={didCompleteRequiredFormFields} 
    // func
    closePopup={() => setPopupType(POPUP_TYPE.CLOSE)} handleChoiceChipClick={({ optionExpectedStartTime }) => handleChoiceChipClick({
            dispatch,
            optionExpectedStartTime,
        })} getIsChoiceChipSelected={({ optionExpectedStartTime }) => getIsChoiceChipSelected({
            optionExpectedStartTime,
            timeSlotList,
        })}/>);
}
